import { create } from "zustand";

export interface TrunkLeafNavigationStore {
	currentScreen: "Trunk" | "Leaf";
	currentLeaf: { props: any } | null;
	navigateToTrunk: () => void;
	navigateToLeaf: (props: any) => void;
	clearLeaf: () => void;
}

export const createTrunkLeafNavigationStore = ({
	onNavigation,
}: {
	onNavigation?: (args: { screen: "Trunk" | "Leaf"; props?: any }) => void;
}) => {
	return create<TrunkLeafNavigationStore>()((set, get) => ({
		currentScreen: "Trunk",
		currentLeaf: null,
		navigateToTrunk: () => {
			set({ currentScreen: "Trunk" });
			onNavigation?.({ screen: "Trunk" });
		},
		navigateToLeaf: (props: any) => {
			set({ currentScreen: "Leaf", currentLeaf: { props } });
			onNavigation?.({ screen: "Leaf", props });
		},
		clearLeaf: () => {
			if (get().currentScreen === "Trunk") {
				set({ currentLeaf: null });
			} else {
				set({ currentScreen: "Trunk", currentLeaf: null });
				onNavigation?.({ screen: "Trunk" });
			}
		},
	}));
};
